/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { DataCenter } from 'cio/models/account';
import AccountService from 'cio/services/account';
import AuthService from 'cio/services/auth';
import AlertsService from 'cio/services/alerts';
import AnalyticsService from 'cio/services/analytics';
import { ProductApp } from 'cio/utils/product-app-info';

interface PrivacyPageArgs {
  expandAccessControls?: boolean;
}

export default class PrivacyPage extends Component<PrivacyPageArgs> {
  @service account!: AccountService;
  @service auth!: AuthService;
  @service alerts!: AlertsService;
  @service analytics!: AnalyticsService;

  DataCenter = DataCenter;
  socImage = new URL('cio/assets/images/data-privacy/soc.png', import.meta.url).toString();
  hipaaImage = new URL('cio/assets/images/data-privacy/hipaa.png', import.meta.url).toString();
  gdprImage = new URL('cio/assets/images/data-privacy/gdpr.png', import.meta.url).toString();

  get expandAccessControls() {
    return this.args.expandAccessControls ?? false;
  }

  @action
  trackLinkClick() {
    this.analytics.track('datacenter', 'learn_more_link_click', {
      dataCenter: this.account.current.isDataCenterEU ? this.DataCenter.US : this.DataCenter.EU,
    });
  }

  get isJourneysActive() {
    return this.account.accessibleProducts.includes(ProductApp.JOURNEYS);
  }
}
